// @flow
import { UPLOAD_SOURCES } from "@cld/upload-widget";
import { asAbsolute } from "root/routes/utils";
import InstagramTab from "../index";

export default [{
	path: asAbsolute(UPLOAD_SOURCES.INSTAGRAM),
	component: InstagramTab,
}];
